import { ColumnDef } from "@tanstack/react-table";
import { displayCountOrDash } from "@/core/utils/number";

interface WithSpiffCounts {
  referral_completion_count: number;
}

const ClosedReferralCol = <T extends WithSpiffCounts>(): ColumnDef<T> => ({
  header: "Referral closed",
  accessorFn: (row) => row.referral_completion_count,
  cell: ({ getValue }) => displayCountOrDash(getValue() as number),
});

export default ClosedReferralCol;
